import React from 'react';
import { logger } from '@/utils/logger';
import { supabase } from '@/lib/supabase';
import type { Database } from '@/lib/database.types';

type FAQItem = Database['public']['Tables']['faqs']['Row'];

export function FAQ() {
  const [faqs, setFaqs] = React.useState<FAQItem[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    async function fetchFAQs() {
      const { data, error } = await supabase
        .from('faqs')
        .select('*')
        .order('order_index');

      if (error) {
        logger.error('Error fetching FAQs:', error);
        return;
      }

      setFaqs(data || []);
      setLoading(false);
    }

    fetchFAQs();
  }, []);

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/3 mb-8" />
          <div className="space-y-6">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="space-y-3">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-4 bg-gray-200 rounded w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold text-gray-900 mb-8">
        Frequently Asked Questions
      </h1>
      
      {faqs.length === 0 ? (
        <div className="text-center text-gray-500">
          No FAQs available
        </div>
      ) : (
        <div className="space-y-6">
          {faqs.map((faq) => (
            <div key={faq.id} className="bg-white shadow overflow-hidden rounded-lg">
              <div className="px-4 py-5 sm:p-6">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  {faq.question}
                </h3>
                <div className="mt-2 text-base text-gray-500">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}